"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBalancesCoinsSectionList = void 0;
const react_1 = require("react");
const Helpers_1 = require("./Helpers");
const Models_1 = require("../Models");
const BalancesCoinsProvider_1 = require("./BalancesCoinsProvider");
function filterData(value) {
    var _a, _b;
    const priceConfig = value.prices;
    const groupSpotData = ((_a = value[Models_1.HoldingGroupType.bot_account].detail) !== null && _a !== void 0 ? _a : []).map((a) => {
        return {
            title: a.title,
            total_in_usdt: a.total_in_usdt,
            data: (0, Helpers_1.combineAccountBalances)(priceConfig, (a.list || [])),
        };
    });
    const groupFuturesData = ((_b = value[Models_1.HoldingGroupType.futures_account].detail) !== null && _b !== void 0 ? _b : []).map((a) => {
        return {
            title: a.title,
            total_in_usdt: a.total_in_usdt,
            data: (0, Helpers_1.combineAccountBalances)(priceConfig, (a.balances || [])),
        };
    });
    return { bot_account: groupSpotData, trader_account: groupFuturesData };
}
const useBalancesCoinsSectionList = (app_lang, isActive) => {
    const info = (0, BalancesCoinsProvider_1.useBalancesCoins)(app_lang, isActive);
    return (0, react_1.useMemo)(() => {
        if (!info) {
            return undefined;
        }
        return filterData(info);
    }, [info]);
};
exports.useBalancesCoinsSectionList = useBalancesCoinsSectionList;
